import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "2rem 0 2rem 3rem",
    cursor: "pointer",
  },
  selectedpaper: {
    padding: "2rem 0 2rem 3rem",
    background: "#edf4fe",
    // opacity: "0.12",
  },
  heading: {
    fontSize: "20px",
    lineHeight: "22px",
    color: "#333333",
  },
  text: {
    fontSize: "56px",
    lineHeight: "62px",
    letterSpacing: "0.05em",
    color: "#333333",
    marginTop: "0.5rem",
  },
}));

export default function ChooseStepTwo({ choosestep2, setChoosestep2, data }) {
  const classes = useStyles();

  return (
    <>
      <Grid container style={{ marginTop: "0.5rem" }} spacing={3}>
        <Grid item md={4} sm={6} xs={12} style={{display:'flex'}}>
          <Paper
            style={{width:'100%'}}
            className={classes.paper}
            // onClick={() => {
            //   setChoosestep2(1);
            // }}
          >
            <Typography className={classes.heading}>Successful Conciliations</Typography>
            <Typography className={classes.text}>{data?.successful_conciliation}</Typography>
          </Paper>
        </Grid>
        <Grid item md={4} sm={6} xs={12} style={{display:'flex'}}>
          <Paper
            style={{width:'100%'}}
            className={classes.paper}
            // onClick={() => {
            //   setChoosestep2(2);
            // }}
          >
            <Typography className={classes.heading}>Unsuccessful Conciliations</Typography>
            <Typography className={classes.text}>{data?.unsuccessful_conciliation}</Typography>
          </Paper>
        </Grid>
        <Grid item md={4} sm={6} xs={12} style={{display:'flex'}}>
          <Paper
            style={{width:'100%'}}
            className={classes.paper}
            // onClick={() => {
            //   setChoosestep2(3);
            // }}
          >
            <Typography className={classes.heading}>
              Arbitrations
            </Typography>
            <Typography className={classes.text}>{data?.arbitrations?.total}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
